import "./App.css";
import React, { useEffect, useState, useContext } from "react";
import { Amplify, Auth, API, graphqlOperation } from "aws-amplify";
import config from "./aws-exports";
import Question from "./Component/Question";
import QuestionSolo from "./Component/QuestionSolo";
import QuestionTailored from "./Component/QuestionTailored";
import QuestionList from "./Component/QuestionList";
import MenuBar from "./Component/MenuBar";
import HomePage from "./Component/Homepage";
import UserContextProvider from "./Component/UserContextProvider";
import UpgradeMembership from "./Component/UpgradeMembership";
import ResumeQuestions from "./Component/ResumeQuestions";

import LogIn from "./Component/LogIn";
import Profile from "./Component/Profile";
import Footer from "./Component/Footer";
import LegalPage from "./Component/LegalPage";
import ProtectedRoute from "./Component/ProtectedRoute";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import UserContext from "./Component/UserContext";
import SocialSigninHandler from "./Component/SocialSinginHandler";

const pickOriginMatch = list => {
  const candidates = String(list || "")
    .split(",")
    .map(s => s.trim())
    .filter(Boolean);
  if (typeof window === "undefined") return candidates[0];
  return (
    candidates.find(u => {
      try {
        return new URL(u).origin === window.location.origin;
      } catch (e) {
        return false;
      }
    }) || candidates[0]
  );
};

const oauthConfig = config.oauth || {};
const resolvedOauth = {
  ...oauthConfig,
  redirectSignIn: pickOriginMatch(oauthConfig.redirectSignIn),
  redirectSignOut: pickOriginMatch(oauthConfig.redirectSignOut)
};

Amplify.configure({ ...config, oauth: resolvedOauth });

function App() {
  const { setUser } = useContext(UserContext);
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const currentUser = await Auth.currentAuthenticatedUser();
        console.log(currentUser);
        setUser(currentUser);
      } catch (error) {
        console.log(error);
        setUser(null);
      }
    };
    checkAuth();
  }, []);
  return (
    <Router>
      <UserContextProvider>
        <div className="App">
          <MenuBar />
          <main className="App-main">
            <AppRoutes />
          </main>
          <Footer />
        </div>
      </UserContextProvider>
    </Router>
  );
}
function AppRoutes() {
  //set all possible routes that the user may navigate to
  return (
    <Routes>
      <Route path="*" element={<HomePage />}></Route>
      <Route path="/jobTailored" element={<QuestionTailored />}></Route>
      <Route path="/import" element={<QuestionList />}></Route>
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      ></Route>
      <Route path="/job" element={<QuestionSolo />}></Route>
      <Route path="/resumeQuestions" element={<ResumeQuestions />}></Route>
      <Route path="/login" element={<LogIn />}></Route>
      <Route path="/upgrade" element={<UpgradeMembership />}></Route>
      <Route path="/social" element={<SocialSigninHandler />}></Route>
      <Route path="/privacy" element={<LegalPage kind="privacy" />}></Route>
      <Route path="/terms" element={<LegalPage kind="terms" />}></Route>
    </Routes>
  );
}
export default App;
